module.exports = __webpack_public_path__ + "static/media/grid-view.083a6a64.svg";